module.exports = __webpack_public_path__ + "img/delete.7f9ec20b.svg";